import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import StripeCheckoutForm from "./StripeCheckoutForm";
import "../../Stripe.css";
import { getPaymentDetails } from "./Utilities";
import Summary from "./Summary";
import PaypalCheckout from "./PaypalCheckout";
import { useQuery } from "../../utils/common";
import FastSpringCheckoutForm from "./FastSpringCheckoutForm";
import "./Payments.css";

//let promise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

let promise = loadStripe(process.env.REACT_APP_TEST_STRIPE_PUBLIC_KEY);
if (window.location.hostname === "www.styldod.com") {
    promise = loadStripe(process.env.REACT_APP_LIVE_STRIPE_PUBLIC_KEY);
}

export default function Payments({
    price,
    setPrice,
    coupon,
    isCpnApplied,
    setIsCpnApplied,
    formSchema,
    stype,
    setCurrentStep,
    setIsError,
    setErrMssge,
    setCouponDis,
    couponDis,
    setPbStep,
    isLoaded,
    setIsLoaded
}) {
    // const [isLoaded, setIsLoaded] = useState(false);
    const [paymentMethod, SetPaymentMethod] = useState("fast_spring");

    const query = useQuery();
    // console.log("PAYMENTS PAGE",query.get("stype"),query.get("order-id"));

    useEffect(() => {
        // analytics code
        if (window.gtag) {
            window.gtag(
                "set",
                "page_path",
                `/user-dashboard#/services-checkout/${formSchema.orderID}`
            );
            window.gtag("event", "page_view");
        }
        try {
            localStorage.setItem("order_amount", price?.totalAmount != null ? price.totalAmount : '');
            localStorage.setItem("number_of_img", formSchema?.number_of_img != null ? formSchema.number_of_img : '');
        }
        catch {
            console.log('error storing data');
        }        
        // console.log(`/user-dashboard#/services-checkout/${formSchema.orderID}`);
        //

        window.history.pushState(
            null,
            null,
            ` ${window.location.origin}/user-dashboard#/services-checkout?order-id=${formSchema.orderID}&stype=${formSchema.stype}`
        );

        // setIsLoaded(false);
if (stype === "subscription") {
  getPaymentDetails(
    isCpnApplied,
    setIsCpnApplied,
    price,
    setPrice,
    couponDis,
    setCouponDis,
    setIsLoaded,
    setIsError,
    setErrMssge,
    formSchema,
    coupon,
    setCurrentStep,
    setPbStep
  );
}
    }, []);

    const onChangePaymentMethodButtonClick = () => {
        SetPaymentMethod(p => {
            try {
                if(p === "fast_spring") {
                    document.querySelector(".switch-new-payemnt-text").style.display = "flex";
                    document.querySelector(".switch-new-payment-button").style.display = "flex";
                    document.querySelector(".switch-old-payemnt-text").style.display = "none";
                    document.querySelector(".switch-old-payment-button").style.display = "none";
                } else {
                    document.querySelector(".switch-new-payemnt-text").style.display = "none";
                    document.querySelector(".switch-new-payment-button").style.display = "none";
                    document.querySelector(".switch-old-payemnt-text").style.display = "flex";
                    document.querySelector(".switch-old-payment-button").style.display = "flex";
                }
            } catch(err) { }
            if(p === "fast_spring") {
                return "stripe"
            } else {
                return "fast_spring"
            }
        })
    }

    return (
        <div>
            <div className="switch-to-old-payment payment-banner-container">
                <div className="div-block-581864">
                    <img
                        src="https://cdn.prod.website-files.com/5dcf94bbedfe6a0469634ea8/675fbb5331c07409adb4b8f9_WarningOctagon.svg"
                        loading="lazy" alt="" className="warning-icon" />
                    <div className="switch-old-payemnt-text payment-info-banner-text">We have updated our payment gateway.</div>
                    <div className="switch-new-payemnt-text payment-info-banner-text">You are using old payment gateway.</div>
                </div>
                <div className="div-block-581865 payment-info-banner-button-container">
                    <a className="switch-old-payment-button w-button payment-info-banner-button payment-banner-switch-button" onClick={onChangePaymentMethodButtonClick}>Switch to old payment gateway</a>
                    <a className="switch-new-payment-button w-button payment-info-banner-button payment-banner-switch-button" onClick={onChangePaymentMethodButtonClick}>Switch to new payment gateway</a>
                    <a href="/contact" target="_blank" className="quick-help w-button payment-info-banner-button payment-banner-help-button">Quick help</a>
                </div>
            </div>
            <div style={{ textAlign: "center" }}>
                { paymentMethod !== "fast_spring" && <div className="ud-mp-txt cc" style={{ marginTop: "20px", fontWeight: "600", fontSize: "20px" }}>
                    Amount to be paid
                </div> }
                {paymentMethod !== "fast_spring" && <div className="ud-mp-amount mp">
                    ${Number(price.totalAmount).toFixed(2)}
                </div>}
                {isCpnApplied ? (
                    <div
                        className="ud-promo-code-cont"
                        style={{ justifyContent: "center" }}
                    >
                        <img
                            src="https://assets.website-files.com/60d5e32a2e61d222f79c6145/60ddad45dd1ecca28f2a02a6_discount-badge.png"
                            loading="lazy"
                            alt=""
                            className="ud-promo-code-image"
                        />
                        <div className="ud-promo-code-txt">
                            Promo code{" "}
                            <span className="ud-promo-code-span">{coupon}</span>{" "}
                            applied
                        </div>
                    </div>
                ) : (
                        ""
                    )}
            </div>
            { paymentMethod === "fast_spring" &&
                <FastSpringCheckoutForm
                    formSchema={formSchema}
                    isCpnApplied={isCpnApplied}
                    price={price}
                    couponDis={couponDis}
                    coupon={coupon}
                    setPbStep={setPbStep}
                />
            }
            { paymentMethod !== "fast_spring" &&
                <div className="ud-payment-cont ud-center" style={{ marginTop: paymentMethod === "fast_spring" && "0px" }}>
                    <div className="ud-payment-form w-form">
                        <div
                            name="email-form"
                            className="ud-stripe-frm"
                            style={{ margin: "auto" }}
                        >
                            {paymentMethod !== "fast_spring" &&
                                <>
                                    <label
                                        htmlFor="cardNumber"
                                        className="ud-chk-lbl mp"
                                        style={{ textAlign: "center" }}
                                    >
                                        Select a payment method:&nbsp;
                                    </label>
                                    <select
                                        style={{
                                            border: "2px solid #e2e2e2",
                                            borderRadius: "8px",
                                        }}
                                        className="ud-pay-opt w-select"
                                        value={paymentMethod}
                                        onChange={(e) => SetPaymentMethod(e.target.value)}
                                    >
                                        <option value="stripe">Credit or debit card</option>
                                        <option value="paypal">Paypal</option>
                                    </select>
                                </>}
                            <div className="ud-stripe-cont">
                                <div style={{ marginTop: paymentMethod !== "fast_spring" ? "40px" : "0px" }}>
                                    {paymentMethod === "stripe" ? (
                                        <Elements stripe={promise}>
                                            {isLoaded ? (
                                                <StripeCheckoutForm
                                                    formSchema={formSchema}
                                                    isCpnApplied={isCpnApplied}
                                                    price={price}
                                                    couponDis={couponDis}
                                                    coupon={coupon}
                                                    setPbStep={setPbStep}
                                                />
                                            ) : (
                                                    ""
                                                )}
                                        </Elements>
                                    ) : paymentMethod === "fast_spring" ? (
                                            <FastSpringCheckoutForm
                                                formSchema={formSchema}
                                                isCpnApplied={isCpnApplied}
                                                price={price}
                                                couponDis={couponDis}
                                                coupon={coupon}
                                                setPbStep={setPbStep}
                                            />
                                        ) :
                                            (
                                                <PaypalCheckout
                                                    formSchema={formSchema}
                                                    isCpnApplied={isCpnApplied}
                                                    price={price}
                                                    couponDis={couponDis}
                                                    coupon={coupon}
                                                    setPbStep={setPbStep}
                                                />
                                            )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div> }
            {formSchema.stype === "single_property_video" ? ("")
                : formSchema.stype === "single_property_website" ? ("")
                    : formSchema.stype === "video_maker" ? ("")
                        : formSchema.stype === "banner" ? ("")
                            : (stype === "subscription" || <Summary formSchema={formSchema} />)}
        </div >
    );
}
